import { render, staticRenderFns } from "./UserRequire2faSection.vue?vue&type=template&id=cb51eb70&scoped=true"
import script from "./UserRequire2faSection.vue?vue&type=script&lang=js"
export * from "./UserRequire2faSection.vue?vue&type=script&lang=js"
import style0 from "./UserRequire2faSection.vue?vue&type=style&index=0&id=cb51eb70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb51eb70",
  null
  
)

export default component.exports